import $script from './script.js';
import Blazy from './blazy.js';
import Cookies from './js.cookie.js';
import './little.js';
import './popup.js';
import viewportUnitsBuggyfill from './viewport-units-buggyfill.js';

import './social-slider.js';

/*------------------------------*\
	current-menu-item home
	little-form little-form__field little-form__label little-form__input button little-form__error
	little-form__col-1-2
	little-form__row little-form__submit .little-form__select
	custom-select body.bookings .little-form
	.contact__family--horizontal .contact__family--circle
\*------------------------------*/
;(function() {
    var throttle = function(type, name, obj) {
        var obj = obj || window;
        var running = false;
        var func = function() {
            if (running) { return; }
            running = true;
            requestAnimationFrame(function() {
                obj.dispatchEvent(new CustomEvent(name));
                running = false;
            });
        };
        obj.addEventListener(type, func);
    };

    /* init - you can init any event */
    throttle ("scroll", "optimizedScroll");
})();

// matches polyfill
window.Element && function(ElementPrototype) {
    ElementPrototype.matches = ElementPrototype.matches ||
    ElementPrototype.matchesSelector ||
    ElementPrototype.webkitMatchesSelector ||
    ElementPrototype.msMatchesSelector ||
    function(selector) {
        var node = this, nodes = (node.parentNode || node.document).querySelectorAll(selector), i = -1;
        while (nodes[++i] && nodes[i] != node);
        return !!nodes[i];
    }
}(Element.prototype);

// closest polyfill
window.Element && function(ElementPrototype) {
    ElementPrototype.closest = ElementPrototype.closest ||
    function(selector) {
        var el = this;
        while (el.matches && !el.matches(selector)) el = el.parentNode;
        return el.matches ? el : null;
    }
}(Element.prototype);


( function( window, document, $$, $, _ ) {

	var blazy = new Blazy();

	function getNodeIndex( node ) {
		var index = 0;
		while ( (node = node.previousSibling) ) {
			if (node.nodeType != 3 || !/^\s*$/.test(node.data)) {
				index++;
			}
		}
		return index;
	}

	function wrap( el, wrapper ) {
		el.parentNode.insertBefore( wrapper, el );
		wrapper.appendChild( el );
	}

	_.ready( function() {

		viewportUnitsBuggyfill.init();

		function offset( el ) {
			var rect = el.getBoundingClientRect(),
			scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
			scrollTop = window.pageYOffset || document.documentElement.scrollTop;
			return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
		}

		/*------------------------------*\
			Masonry
		\*------------------------------*/
		var masonry = $$( '.do-masonry' );

		if( masonry.length ) {

			$script( 'https://cdnjs.cloudflare.com/ajax/libs/packery/1.4.3/packery.pkgd.min.js', function() {

				var music = $( 'div.music' );
				if( music ) {

					var player = $( '.music-audio' );
					var needle = $( '.music__needle' );
					var vinyl = $( '.music__vinyl' );
					var isPlaying = false;

					// var masonryMusic = new Packery( music, {
					// 	itemSelector: '.music-item',
					// 	columnWidth: '.music__sizer',
					// 	percentPosition: true,
					// 	stamp: '.music__stamp'
					// } );
					// masonryMusic.layout();

					var playlist = $( '.music__playlist' );
					var trackList = $$( '.music__playlist a' );
					var tracks = [];
					var currentTrack = -1;

					for( var i = 0; i < trackList.length; i++ ) {
						tracks.push( trackList[i].getAttribute( 'href' ) );
					}


					_.on( 'click', playlist, 'a', function( e ) {

						e.preventDefault();

						playTrack( getNodeIndex( this.closest( 'li' ) ) );

					} );

					var playBtn = $( '.music__play .icon' );
					_.on( 'click', $( '.music__play' ), function() {
						_.toggleClass( playBtn, 'icon--play' );
						_.toggleClass( playBtn, 'icon--pause' );
						if( currentTrack === -1 ) {
							// start from beginning
							playTrack( 0 );
						} else if( isPlaying ) {
							player.pause();
							isPlaying = false;
							_.removeClass( vinyl, 'music__vinyl--active' );
							_.addClass( vinyl, 'music__vinyl--paused' );
						} else {
							player.play();
							isPlaying = true;
							_.addClass( vinyl, 'music__vinyl--active' );
							_.removeClass( vinyl, 'music__vinyl--paused' );
						}
					} );

					_.on( 'click', $( '.music__stop' ), function() {
						player.pause();
						player.removeAttribute( 'src' );
						isPlaying = false;
						currentTrack = -1; // reset
						_.removeClass( needle, 'music__needle--active' );
						setTimeout( function() {
							_.removeClass( vinyl, 'music__vinyl--active' );
							_.addClass( vinyl, 'music__vinyl--paused' );
						}, 800 );
						_.removeClass( trackList, 'music-track--active' );

						_.addClass( playBtn, 'icon--play' );
						_.removeClass( playBtn, 'icon--pause' );
					} );

					_.on( 'click', $( '.music__next' ), playNextTrack );
					player.addEventListener( 'ended', playNextTrack );

					_.on( 'click', $( '.music__prev' ), function() {
						currentTrack--;
						if( currentTrack < 0 ) {
							currentTrack = tracks.length - 1;
						}
						playTrack( currentTrack );
					} );

					function playTrack( index ) {

						currentTrack = index;

						player.src = tracks[currentTrack];
						player.play();
						isPlaying = true;

						_.addClass( needle, 'music__needle--active' );
						setTimeout( function() {
							_.addClass( vinyl, 'music__vinyl--active' );
							_.removeClass( vinyl, 'music__vinyl--paused' );
						}, 800 );

						_.removeClass( trackList, 'music-track--active' );
						_.addClass( trackList[index], 'music-track--active' );

						_.removeClass( playBtn, 'icon--play' );
						_.addClass( playBtn, 'icon--pause' );

					}

					function playNextTrack() {
						currentTrack++;
						if( currentTrack >= tracks.length ) {
							currentTrack = 0;
						}
						playTrack( currentTrack );
					}

				}

				/*------------------------------*\
					Gallery
				\*------------------------------*/
				var gallery = $( 'div.gallery' );

				if( gallery ) {

					var masonryGallery = new Packery( gallery, {
						itemSelector: '.gallery-item',
						columnWidth: '.gallery__sizer',
						percentPosition: true
					} );

					masonryGallery.on( 'layoutComplete', function( items ) {

						blazy.revalidate();

					} );

				}

			} );

		}

		/*------------------------------*\
			Nav
		\*------------------------------*/
		var nav = $( '.nav-main' );
		var navToggle = $( '.nav-main__toggle a' );
		var mobileTop = $( '.mobile-top' );

		_.on( 'click', navToggle, function( e ) {

			e.preventDefault();

			_.toggleClass( nav, 'nav-main--active' );
			_.toggleClass( mobileTop, 'mobile-top--active' );

		} );

		/*------------------------------*\
			Cat
		\*------------------------------*/
		if( $( 'body.home' ) ) {

			var cat = $( '.header__cat' );
			var catFixed = cat.cloneNode( true );
			_.addClass( catFixed, 'header__cat--fixed' );
			_.removeClass( catFixed, 'header__cat--main' );
			_.removeClass( catFixed, 'header__cat--active' );

			cat.parentNode.appendChild( catFixed );

			var catTop = offset( cat ).top;
			var catMiddle = catTop + ( cat.offsetHeight / 2 );

			window.addEventListener('optimizedScroll', function(){

				if( window.scrollY > catMiddle ) {

					_.removeClass( cat, 'header__cat--active' );
					_.addClass( catFixed, 'header__cat--active' );

				} else {

					_.addClass( cat, 'header__cat--active' );
					_.removeClass( catFixed, 'header__cat--active' );

				}

			});

		}


		/*------------------------------*\
			Date Picker
		\*------------------------------*/
		var bookingDate = $( '.booking-date input' );
		var bookingTime = $( '.booking-time input' );

		if( bookingDate ) {

			$script( 'https://cdnjs.cloudflare.com/ajax/libs/rome/2.1.22/rome.min.js', function() {

				function pad(n, width, z) {
					z = z || '0';
					n = n + '';
					return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
				}

				var d = new Date();
				console.log(rome.moment().format('Do MMM'));

				rome( bookingDate, {
					time: false,
					inputFormat: 'Do MMM',
					weekStart: 1,
					min: rome.moment().format('Do MMM'),
					styles: {
						container: 'rd-container rd-container--date'
					}
				} );

				rome( bookingTime, {date: false} );

			} );

		}

		/*------------------------------*\
			Custom Select
		\*------------------------------*/
		var select = $$( '.little-form__select select' );

		if( select.length ) {

			for( var s = 0; s < select.length; s++ ) {

				var wrapper = document.createElement( 'div' );
				wrapper.className = 'custom-select';

				wrap( select[s], wrapper );

			}

		}

		/*------------------------------*\
			Contact Family
		\*------------------------------*/
		var contactFamily = $( '.contact__family' );
		function updateFamily() {
			if( _.windowWidth() < 1000 ) {
				_.removeClass( contactFamily, 'contact__family--horizontal' );
				_.addClass( contactFamily, 'contact__family--circle' );
			} else {
				_.removeClass( contactFamily, 'contact__family--circle' );
				_.addClass( contactFamily, 'contact__family--horizontal' );
			}
		}

		if( contactFamily ) {
			updateFamily();
			window.addEventListener( 'resize', updateFamily );
		}

	} );


} )( window, document, little.qsa, little.qs, little.util );


//Homepage video
$( document ).ready(function() {


    $('.playBtn').click(function() {
        $(".video").removeClass("hide");
    });

    var urlDump = $('#video').attr('src');
  var url = $('#video').attr('src');

  $('.playBtn').click(function(){
	  $('#video').attr('src', urlDump);
	  console.log(urlDump);
  });

  $('.hero__close').click(function(){
	  $('#video').attr('src', '');
	  console.log('asd');
      $(".video").addClass("hide");
  });










    var homePopup = document.querySelector('.overlay');

	// if(!Cookies.get('ModalCookie')) {
        if(homePopup) {
            homePopup.addEventListener('click', function(){
                this.classList.add('closed');
                setTimeout(function() {
                    homePopup.classList.add('closed-z-index');
                }, 401);
                // if(!Cookies.get('ModalCookie')) {
                //     setCloseModalCookie();
                // }
            });
        }
    // }



    /*
    Modal
     */
	function setCloseModalCookie() {

		// Generate Random String
		var cookieValue = makeId();
        // Cookies.set('ModalCookie', cookieValue, { expires: 1, domain: 'calllanesocial.co.uk' });
        Cookies.set('ModalCookie', cookieValue, { expires: 1, domain: 'localhost/call-lane-social' });
    }

	function makeId() {
		var text = "";
		var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

		for( var i=0; i < 10; i++ )
			text += possible.charAt(Math.floor(Math.random() * possible.length));

		return text;
	}





});






// WEBPACK FOOTER //
// ./main.js